const Accordion = () => {
  const $body = $('body')
  const $target = $body.find('.accordion')
  if ($target.length) {
    $target.on('click', (evt) => {
      const $el = $(evt.currentTarget)
      const $panel = $el.next('.panel')
      if ($panel.hasClass('hidden')) {
        $panel.removeClass('hidden')
      } else {
        $panel.addClass('hidden')
      }
    })
  }
}

export default Accordion



// WEBPACK FOOTER //
// ./scripts/components/Accordion.js